import { constants as orderConstants } from 'utils/order';

import { actions as extrasDirectOrderActions } from 'state/direct-order/extras';
import { actions as uiDirectOrderActions } from 'state/direct-order/ui';
import { actions as quoteDirectOrderActions } from 'state/direct-order/quote';
import { actions as repeatedFromDirectOrderActions } from 'state/direct-order/repeated-from';
import { actions as shipmentDirectOrderActions } from 'state/direct-order/shipments';

import { actions as extrasDirectOrderRecurringActions } from 'state/direct-order-recurring/extras';
import { actions as uiDirectOrderRecurringActions } from 'state/direct-order-recurring/ui';
import { actions as quoteDirectOrderRecurringActions } from 'state/direct-order-recurring/quote';
import { actions as repeatedFromDirectOrderRecurringActions } from 'state/direct-order-recurring/repeated-from';
import { actions as shipmentDirectOrderRecurringActions } from 'state/direct-order-recurring/shipments';
import { actions as rangeDirectOrderRecurringActions } from 'state/direct-order-recurring/range';
import { actions as daysDirectOrderRecurringActions } from 'state/direct-order-recurring/days';
import { actions as holidaysDirectOrderRecurringActions } from 'state/direct-order-recurring/holidays';

import { actions as extrasMrDistributionActions } from 'state/mrDistribution/extras';
import { actions as extrasMrCollectionnActions } from 'state/mrCollection/extras';

import { actions as uiMrDistributionActions } from 'state/mrDistribution/ui';
import { actions as uiMrCollectionActions } from 'state/mrCollection/ui';

import { actions as quoteMrDistributionActions } from 'state/mrDistribution/quote';
import { actions as quoteMrCollectionActions } from 'state/mrCollection/quote';

import { actions as repeatedFromMrDistributionActions } from 'state/mrDistribution/repeated-from';
import { actions as repeatedFromMrCollectionActions } from 'state/mrCollection/repeated-from';

import { actions as shipmentMrDistributionActions } from 'state/mrDistribution/shipments';
import { actions as shipmentMrCollectionActions } from 'state/mrCollection/shipments';

const extras = {
  [orderConstants.DIRECT_ORDER]: extrasDirectOrderActions,
  [orderConstants.DIRECT_ORDER_RECURRING]: extrasDirectOrderRecurringActions,
  [orderConstants.DISTRIBUTION]: extrasMrDistributionActions,
  [orderConstants.COLLECTION]: extrasMrCollectionnActions,
};

const ui = {
  [orderConstants.DIRECT_ORDER]: uiDirectOrderActions,
  [orderConstants.DIRECT_ORDER_RECURRING]: uiDirectOrderRecurringActions,
  [orderConstants.DISTRIBUTION]: uiMrDistributionActions,
  [orderConstants.COLLECTION]: uiMrCollectionActions,
};

const quote = {
  [orderConstants.DIRECT_ORDER]: quoteDirectOrderActions,
  [orderConstants.DIRECT_ORDER_RECURRING]: quoteDirectOrderRecurringActions,
  [orderConstants.DISTRIBUTION]: quoteMrDistributionActions,
  [orderConstants.COLLECTION]: quoteMrCollectionActions,
};

const repeatedFrom = {
  [orderConstants.DIRECT_ORDER]: repeatedFromDirectOrderActions,
  [orderConstants.DIRECT_ORDER_RECURRING]:
    repeatedFromDirectOrderRecurringActions,
  [orderConstants.DISTRIBUTION]: repeatedFromMrDistributionActions,
  [orderConstants.COLLECTION]: repeatedFromMrCollectionActions,
};

const shipments = {
  [orderConstants.DIRECT_ORDER]: shipmentDirectOrderActions,
  [orderConstants.DIRECT_ORDER_RECURRING]: shipmentDirectOrderRecurringActions,
  [orderConstants.DISTRIBUTION]: shipmentMrDistributionActions,
  [orderConstants.COLLECTION]: shipmentMrCollectionActions,
};

const range = {
  [orderConstants.DIRECT_ORDER_RECURRING]: rangeDirectOrderRecurringActions,
};

const days = {
  [orderConstants.DIRECT_ORDER_RECURRING]: daysDirectOrderRecurringActions,
};

const holidays = {
  [orderConstants.DIRECT_ORDER_RECURRING]: holidaysDirectOrderRecurringActions,
};

export default {
  extras,
  ui,
  quote,
  repeatedFrom,
  shipments,
  range,
  days,
  holidays,
};
